/*
 * @Description:
 * @Author: xiawenlong
 * @Date: 2021-03-22 19:09:00
 * @LastEditors: xiawenlong
 * @LastEditTime: 2021-07-06 11:31:43
 */
import Layout from '@/layout'

export default [
  {
    path: '/course',
    component: Layout,
    redirect: '/course/class',
    children: [
      {
        path: 'class',
        name: 'CourseClass',
        component: () =>
          import(/*webpackChunkName:'CourseClass'*/ '@/views/course/CourseClass/index'),
        meta: { title: '课程商城', homePage: true },
      },
    ],
  },
  {
    path: '/course/play/:productId',
    name: 'CoursePlay',
    component: () => import(/*webpackChunkName:'CoursePlay'*/ '@/views/course/CoursePlay'),
    meta: { title: '播放' },
  },
  {
    path: '/course/live/:productId',
    name: 'CourseLive',
    component: () => import(/*webpackChunkName:'CourseLive'*/ '@/views/course/CourseLive'),
    meta: { title: '直播' },
  },
  {
    path: '/course/study/:classId/:courseId',
    name: 'CourseStudy',
    component: () => import(/*webpackChunkName:'CourseStudy'*/ '@/views/course/CourseStudy'),
    meta: { title: '播放' },
  },
  {
    path: '/course/studyLive/:classId/:courseId',
    name: 'CourseStudyLive',
    component: () =>
      import(/*webpackChunkName:'CourseStudyLive'*/ '@/views/course/CourseStudyLive'),
    meta: { title: '直播' },
  },
  {
    path: '/course/list',
    name: 'CourseList',
    component: () => import(/*webpackChunkName:'CourseList'*/ '@/views/course/CourseList'),
    meta: { title: '课程列表' },
  },
  {
    path: '/course/:organizationId/:productId',
    name: 'CourseDetail',
    component: () => import(/*webpackChunkName:'CourseDetail'*/ '@/views/course/CourseDetail'),
    meta: { title: '课程详情' },
  },
  {
    path: '/pay/:orderId',
    name: 'Pay',
    component: () => import(/*webpackChunkName:'Pay'*/ '@/views/pay/index.vue'),
    meta: { title: '支付订单' },
  },
]
